import { render, staticRenderFns } from "./PaySlips.vue?vue&type=template&id=707f2de0&"
import script from "./PaySlips.vue?vue&type=script&lang=js&"
export * from "./PaySlips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports